export default __webpack_public_path__ + "static/media/March2014.88f25403.png";